(ns ncr.amplitude
  (:require
   [clojure.string :as str]
   [cljs.core.async :as async :refer [<!] :refer-macros [go]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [malli.core :as m]
   [malli.transform :as mt]
   [ncr.sysinfo :as sysinfo]
   [ncr.etc.util :as u]
   ["@amplitude/analytics-browser" :as a]))


(defn identify! [& {:keys [set set-once]}]
  (let [identify (a/Identify.)]
    (doseq [[k v] set]
      (.set identify (name k) (clj->js v)))

    (doseq [[k v] set-once]
      (.setOnce identify (name k) (clj->js v)))
    (a/identify identify)))

(defonce _analytics
  (go
    (u/error-m
      [info (<! sysinfo/info)
       instance (get-in info [:server :instance] "dev")]
      (<p!
        (.-promise
          (a/init
            (if (= instance "prod")
              "269963c58192a22f778ccb438ff39757"
              "a10e3e01b18f6c87c3345c1f73a9c2d0")
            #js {"serverZone" "EU"
                 "defaultTracking"
                 #js {"attribution" true
                      "pageViews" false
                      "sessions" true,
                      "formInteractions" false,
                      "fileDownloads" false}
                 "transport" "beacon"})))

      (identify! :set
        (let []
          {"Instance" instance
           "Version" (get-in info [:client :version] "0.0")
           "Build"
           (u/format "%s-%s"
             (get-in info [:client :commit])
             (get-in info [:client :build]))})))))

(defn device-id []
  (a/getDeviceId))

(defn set-user-id! [uid]
  (a/setUserId uid))

(defn- transformer []
  (mt/transformer
    {:decoders
     {:string
      {:compile
       (fn [schema _]
         (when (get (m/properties schema) :replace-blank?)
           (fn [s]
             (if (str/blank? s)
               "<blank>"
               s))))}}}))

(defn- track!
  ([track-name]
   (let [track-name (name track-name)]
     (a/track (str "[NCR] " track-name))))
  ([track-name spec props]
   (let [track-name (name track-name)]
     (let [spec (into [:map] spec)]
       (if (m/validate spec props)
         (let [transformed (m/decode spec props transformer)]
           (a/track (str "[NCR] " track-name) (clj->js transformed)))
         (.error js/console (u/format "Amplitude: Invalid Event '%s'" props)))))))

(def switch-cluster!
  (partial track! "Switch Cluster"
    [["From" :string]
     ["To" :string]
     ["Origin" [:enum "Dialog" "Masthead"]]]))

(def cluster-selected!
  (partial track! "Cluster Selected"
    [["Cluster" :string]]))

(def search!
  (partial track! "Search"
    [["Query" [:string {:replace-blank? true}]]
     ["Modify" {:optional true} [:enum "Toggle"]]
     ["Origin"
      [:enum "Sidebar" "Masthead Input" "Masthead Reset" "Search Item" "Fragment" "Report" "Empty Search"]]]))

(def locations
  [:enum "Sidebar" "Search" "Fragment" "Attachment"
   "Manage Accounts" "Manage Labels" "Manage Folders" "Manage DATEV" "Manage AI Assist" "Reports"])

(def navigate!
  (partial track! "Navigate"
    [["Origin" locations]
     ["Destination" (into locations ["<back>"])]
     ["Target"
      {:optional true}
      [:enum "Blank" "Blank Window"]]]))

#_(def search-reset!
    (partial track! "Search Reset"
      [["Origin" [:enum "Masthead" "Search"]]]))

(def cheat-sheet!
  (partial track! "Cheat Sheet"
    [["Duration" :int]]))

(defn wrap [track! fn & args]
  (track!)
  (apply fn args))